import { analyticsConfig } from './config';

export function trackPageView(path) {
  const pagePath = path || (typeof window !== 'undefined' ? `${window.location.pathname}${window.location.search}` : '/');

  if (analyticsConfig.gaMeasurementId && typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_location: window.location.href,
      page_title: document.title,
    });
  }

  if (analyticsConfig.metaPixelId && typeof window.fbq === 'function') {
    window.fbq('track', 'PageView');
  }
}
